'use es6';
/*
 * https://git.hubteam.com/HubSpot/DesignManagerApi/pull/1035
 */

import http from 'hub-http/clients/apiClient';
import * as UserKeys from 'DesignData/enums/attributes/User';
import * as UserPortalKeys from 'DesignData/enums/attributes/UserPortal';
import * as PortalKeys from 'DesignData/enums/attributes/Portal';
import { toSlug } from 'DesignData/lib/text';
const URI_BASE_USER = 'designmanager/v1/attributes/user';
const URI_BASE_USER_PORTAL = 'designmanager/v1/attributes/user/portal';
const URI_BASE_PORTAL = 'designmanager/v1/attributes/portal';
const URI_META = 'designmanager/v1/attributes/meta';

function attributesClientFactory(keys, uriBase) {
  function validateKey(key) {
    if (keys[key]) {
      return;
    }

    throw new TypeError(`Invalid API key for ${uriBase}: ${key}`);
  }

  const createSlugFromKey = key => encodeURIComponent(toSlug(key));

  return {
    /**
     * @param {String} key
     * @returns {Promise}
     */
    fetch(key) {
      validateKey(key);
      return http.get(`${uriBase}/${createSlugFromKey(key)}`);
    },

    /**
     * @param {String} key
     * @param {Object} data
     * @returns {Promise}
     */
    save(key, data) {
      validateKey(key);
      return http.put(`${uriBase}/${createSlugFromKey(key)}`, {
        data
      });
    }

  };
}
/**
 * Specific to PORTAL
 */


export const Portal = attributesClientFactory(PortalKeys, URI_BASE_PORTAL);
/**
 * Specific to USER
 */

export const User = attributesClientFactory(UserKeys, URI_BASE_USER);
/**
 * Specific to USER + PORTAL
 */

export const UserPortal = attributesClientFactory(UserPortalKeys, URI_BASE_USER_PORTAL);
export function fetchAttributesMeta() {
  return http.get(URI_META);
}
export const saveOnboardingSettings = data => {
  return http.put(`${URI_BASE_USER}/onboardingSettings`, {
    data
  });
};